import React from 'react';
import { createResolver } from './assets';

import Slide1Video from '../components/charly-palmer/1_Video';
import Slide2SplitSticky from '../components/charly-palmer/2_SplitSticky';
import Slide3Audio from '../components/charly-palmer/3_Audio';
import Slide4Video from '../components/charly-palmer/4_Video';
import Slide41Video from '../components/charly-palmer/4_5_Video';
import Slide5Video from '../components/charly-palmer/5_Video';
import Slide6Audio from '../components/charly-palmer/6_Audio';
import Slide7Video from '../components/charly-palmer/7_Video';
import Slide8Video from '../components/charly-palmer/8_Video';
import Slide9Video from '../components/charly-palmer/9_Video';

const { resolveImage, resolveAudio } = createResolver('charly-palmer');

const story = {
  artist: {
    name: 'Charly Palmer',
    occupation: 'painter',
  },
  header: {
    image: {
      src: resolveImage('SIG_7721 1.jpg'),
    },
    copy: {
      text: (
        <>
          Meet Charly Palmer,
          <br />
          the Artist &amp; Illustrator Exploring the Experiences
          <br />
          of Black Americans
        </>
      ),
    },
  },
  slides: [
    {
      id: 'slide-1',
      component: Slide1Video,
      props: {
        video: {
          id: 510182479,
        },
        images: [],
        copy: [
          {
            text: (
              <>
                For over 25 years, Atlanta-based fine artist Charly Palmer has
                sought to tell the story of Black Americans through his work. As
                an alumnus of several notable art schools, Palmer has dedicated
                his personal and professional life to exploring the experiences
                of African Americans.
              </>
            ),
          },
        ],
        audio: {
          url: resolveAudio('04_Audio_SL_CP.mp3'),
        },
      },
    },
    {
      id: 'slide-2-split-sticky',
      component: Slide2SplitSticky,
      props: {
        images: [
          {
            src: resolveImage('SIG_0870CP 1.jpg'),
          },
        ],
        copy: [
          {
            text: (
              <>
                He’s perhaps best known for using layered textures and patterns
                to illustrate notable Black figures, followed by a floral motif
                that’s become a signature detail in his work. Some of his most
                high-profile work came last year when he was tasked with
                creating the album cover for one of the most prominent soul and
                R&amp;B singers of our generation. Then, in the wake of
                America’s racial reckoning last summer, Palmer was commissioned
                by a critically-acclaimed magazine to create a cover for its
                “America Must Change” issue.
              </>
            ),
          },
        ],
      },
    },
    {
      id: 'slide-3-audio',
      component: Slide3Audio,
      props: {
        audio: {
          url: resolveAudio('01_Audio_SL_CP-r2.m4a'),
        },
        copy: [
          {
            text: (
              <>
                As one of the more established artists exhibiting at Jack Honey
                Art, Beats &amp; Lyrics, we connected with Palmer to learn more
                about his background, what inspires him creatively, what it’s
                like working with Jack Honey Art, Beats &amp; Lyrics, his advice
                for emerging artists, and more.
              </>
            ),
          },
          {
            text: (
              <>
                As one of the more established artists exhibiting at Jack Honey
                Art, Beats &amp; Lyrics, we connected with Palmer to learn more
                about his background, what inspires him creatively, what it’s
                like working with Jack Honey Art, Beats &amp; Lyrics, his advice
                for emerging artists, and more.
              </>
            ),
          },
        ],
      },
    },
    {
      id: 'slide-4-video',
      component: Slide4Video,
      props: {
        video: {
          id: 511222240,
        },
        images: [
          {
            src: resolveImage('SIG_1232CP 1.jpg'), // desktop only
          },
        ],
        copy: [
          {
            text: (
              <>Charly tells us why he does what he does every single day.</>
            ),
          },
        ],
      },
    },

    {
      id: 'slide-5-video',
      component: Slide5Video,
      props: {
        video: {
          id: 511245036,
        },
        images: [
          {
            src: resolveImage('SIG_1232CP 1.jpg'), // mobile only
          },
          {
            src: resolveImage('SIG_0621CPCP2-2 1.jpg'),
          },
          {
            src: resolveImage('SIG_1133CP.jpeg'),
          },
        ],
        copy: [
          {
            text: (
              <>
                &ldquo;Black people have always been and will always be my
                inspiration.&rdquo;
              </>
            ),
          },
          {
            text: <>He explains the freedom behind his work.</>,
          },
          {
            text: (
              <>
                &ldquo;What I’ve learned is when the canvas speaks to you, you
                listen.&rdquo;
              </>
            ),
          },
        ],
      },
    },
    {
      id: 'slide-6-audio',
      component: Slide6Audio,
      props: {
        audio: {
          url: resolveAudio('03_Audio_SL_CP-r2.mp3'),
        },

        copy: [
          {
            text: (
              <>
                For anyone unfamilar with Charly&apos;s oeuvre, this is his goal
                for every piece he creates.
              </>
            ),
          },
        ],
      },
    },
    {
      id: 'slide-7-video',
      component: Slide7Video,
      props: {
        video: {
          id: 510182863,
        },
        images: [
          {
            src: resolveImage('SIG_0621CPCP2-2 1_1.jpg'),
          },
          {
            src: resolveImage('SIG_1133CP 1_1.jpg'),
          },
        ],
      },
    },
    {
      id: 'slide-8-video',
      component: Slide8Video,
      props: {
        audio: {
          url: resolveAudio('05_Audio_SL_CP.mp3'),
        },
        video: {
          id: 510184071,
        },
        images: [
          {
            src: resolveImage('SIG_0712CP.jpg'),
          },
        ],
        copy: [
          {
            text: (
              <>
                He explains what drew him to Jack Honey Art, Beats &amp; Lyrics
                and how it&apos;s different from other shows.
              </>
            ),
          },
        ],
      },
    },
    {
      id: 'slide-9-video',
      component: Slide9Video,
      props: {
        audio: {
          url: resolveAudio('02_Audio_SL_CP.mp3'),
        },
        video: {
          id: 510183212,
        },
        images: [
          {
            src: resolveImage('SIG_0621CPCP2-2.jpg'),
          },
          {
            src: resolveImage('SIG_1133CP 1.jpg'),
          },
        ],
        copy: [
          {
            text: (
              <>
                For all the up-and-coming artists out there, he has a few words
                of advice.
              </>
            ),
          },
          {
            text: (
              <>
                &ldquo;Social media is the key. Be visible, follow people that
                inspire you, but be patient.&rdquo;
              </>
            ),
          },
        ],
      },
    },
    {
      id: 'slide-4_5-video',
      component: Slide41Video,
      props: {
        video: {
          id: 511235406,
        },
      },
    },
  ],
  credits: [
    {
      role: 'Sr. Brand Producer',
      name: 'Chad Ghiron',
    },
    {
      role: 'Manager, Activations',
      name: 'Wenona Carlos',
    },
    {
      role: 'Local Producer',
      name: 'Isaiah Moses',
    },
    {
      role: 'Director',
      name: 'Motion Family',
    },
    {
      role: 'Executive Producer',
      name: 'David KA',
    },
    {
      role: 'Producer',
      name: 'Liv Higgins',
    },
    {
      role: 'Production Assistant',
      name: 'Brittany Groy',
    },
    {
      role: 'Director of Photograpy',
      name: 'Cristian Bernal',
    },
    {
      role: '1st AC',
      name: 'Tre Loren',
    },
    {
      role: 'Photographer',
      name: 'Jorge Sigala',
    },
  ],
};

export default story;
